// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"4e414c2b","492":"9218e998"}[chunkId] + ".chunk.css";
};